import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import ErrorBanner from '@avtechsoftware/react-component-library/src/components/common/ErrorBanner';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import ModalComponent from '../../../../layout/Modals/ModalComponent/ModalComponent';
import { connectModalContainerContextToComponent } from '../../../../../contexts/ModalContext/ModalContext';
import TagPropType from '../../../../../utility/PropTypes/tagPropType';
import { editTag } from '../../../../../redux/slices/tagListSlice/tagListSlice';

function EditTagModal({
  setModalJSX,
  tag,
}) {
  const dispatch = useDispatch();
  const [show, setShow] = useState(true);
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [editedName, setEditedName] = useState(tag.name);

  const closeModalHandler = () => {
    setShow(false);
    setModalJSX((<></>));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    if (editedName.length < 1 || editedName.length > 100) {
      setError('Tag label must be between 1 and 100 characters long.');
      setSubmitting(false);
      return false;
    }
    const tagPatchData = {
      editedFields: {
        name: editedName,
      },
      editedTagId: tag.id,
      patchFields: ['name'],
    };
    try {
      await dispatch(editTag(tagPatchData)).unwrap();
      closeModalHandler();
    } catch (err) {
      setError('Unexpected error editing tag. Please try again.');
    } finally {
      setSubmitting(false);
    }
    return true;
  };

  /* istanbul ignore next */
  return (
    <ModalComponent
      showConfirmCallToAction
      show={show}
      close={closeModalHandler}
      confirmButtonText="Apply Changes"
      confirmButtonAction={handleSubmit}
      isBtnDisabled={submitting}
    >
      <Modal.Header>
        <Modal.Title>
          Edit Tag
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="px-3">
          <form>
            {error && (
            <div className="row">
              <div className="col">
                <ErrorBanner onCloseError={() => setError('')}>
                  {error}
                </ErrorBanner>
              </div>
            </div>
            )}
            <div className="form-group row justify-content-center">
              {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
              <label
                className="col-sm-2 col-form-label text-right"
                htmlFor="editTagInput"
              >
                Tag
              </label>
              <div className="col-sm-10">
                <input
                  type="text"
                  className="form-control"
                  id="editTagInput"
                  onChange={(e) => setEditedName(e.target.value)}
                  value={editedName}
                />
              </div>
            </div>
          </form>
        </div>
      </Modal.Body>
    </ModalComponent>
  );
}

EditTagModal.propTypes = {
  setModalJSX: PropTypes.func.isRequired,
  tag: PropTypes.shape(TagPropType).isRequired,
};
export { EditTagModal };
export default connectModalContainerContextToComponent(EditTagModal);
